import { Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { SpacedRow } from '../../../styles/commonStyledComponents'
import { Button, ButtonType } from '../../Common/Button'

export interface IDiscountsHeaderProps {
  onNewDiscountPressed: () => void
}

const DiscountsHeader = (props: IDiscountsHeaderProps): JSX.Element => {
  const { onNewDiscountPressed } = props

  const { t } = useTranslation()

  return (
    <StyledSpacedRow>
      <Typography variant='h4'>{t('discounts')}</Typography>
      <Button
        label={t('new_discount')}
        mode={ButtonType.SUCCESS_MAIN}
        startIcon={<AddIcon />}
        onClick={onNewDiscountPressed}
      />
    </StyledSpacedRow>
  )
}

const StyledSpacedRow = styled(SpacedRow)`
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
`

export default DiscountsHeader
